<template>
    <label class="checkbox-wrapper">
        <input type="checkbox" class="checkbox" :checked="value" @change="$emit('input', $event.target.checked)">
        <span class="checkbox-label">
            <IconCheck v-if="value"/>
        </span>
        <span class="checkbox-title">{{ label }}</span>
    </label>
</template>

<script>
import IconCheck from '../icons/IconCheck.vue';

export default {
    name: "FormCheckbox",
    components: {IconCheck},
    props: ['value', 'label']
}
</script>

<style lang="scss">
@import "../../../../sass/front/helpers";

.checkbox {
    opacity: 0;
    visibility: hidden;
    position: absolute;

    &-wrapper {
        display: flex;
        align-items: center;
        gap: 6px;
        cursor: pointer;

        @include responsive-below($sm){
            width: 100%;
            order: 1;
        }

        & + & {
            margin-left: 3rem;

            @include responsive-below($sm){
                margin-left: 0;
            }
        }
    }

    &:checked + .checkbox-label {
        background: $color-brand;
        border-color: $color-brand;
        color: #fff;
    }

    &-label {
        width: 24px;
        min-width: 24px;
        height: 24px;
        border: solid 2px #dadada;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
    }
}

</style>
